import React, { useEffect, useState } from "react";
import ModalWrapper from "../../../../../Components/Modals/ModalWrapper";
import Permissions from "./Permissions";
import NotificationEmailManager from "../../../../Shipper/Customer/MainPages/Settings/SystemsSettings/NotificationEmailManager";
import { useTranslation } from "react-i18next";

const ClientSettings = ({ open, setOpen, setSnack, onClientUpdated }) => {
  const { t } = useTranslation(["warehouse", "common"]);
  const tabs = [
    { id: "permissions", label: t("clientSettings.permissions") },
    { id: "email", label: t("clientSettings.emailConfiguration") },
  ];
  const [activeTab, setActiveTab] = useState("permissions");

  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (open) setActiveTab("permissions");
  }, [open]);

  const username = open?.shipper?.username ?? open?.username ?? "";
  const businessName =
    open?.shipper?.business_name ?? open?.business_name ?? "";

  const renderTabContent = () => {
    switch (activeTab) {
      case "permissions":
        return (
          <Permissions
            client={open}
            setSnack={setSnack}
            onClientUpdated={onClientUpdated}
          />
        );
      case "email":
        return <NotificationEmailManager userWarehouseId={open?.id} />;
      default:
        return null;
    }
  };

  return (
    <ModalWrapper
      isOpen={!!open}
      boxClassName="!w-full !max-w-7xl max-h-[95vh] overflow-hidden p-0 m-2 !border-none"
      backdropClassName="bg-black bg-opacity-50"
    >
      <div className="bg-ui-surface rounded-lg shadow-xl w-full max-h-[95vh] overflow-hidden">
        <div className="bg-brand px-3 sm:px-4 md:px-6 py-3 md:py-4">
          <div className="flex items-center justify-between">
            <div className="w-8"></div>
            <h1 className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-white text-center flex-1 px-2">
              {t("clientSettings.clientSettings")} {username && `— ${username}`}
              {businessName && ` (${businessName})`}
            </h1>
            <button
              onClick={handleClose}
              className="text-white hover:text-ui-border transition-colors p-1"
              title={t("common:actions.close")}
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="bg-ui-surface border-b border-ui-border">
          <div className="flex justify-start sm:justify-center space-x-1 px-2 sm:px-4 md:px-6 overflow-x-auto scrollbar-hide">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`relative py-2 my-2 px-2 sm:px-3 md:px-4 lg:px-6 font-medium text-xs sm:text-sm transition-all duration-300 whitespace-nowrap rounded-tl-lg rounded-tr-lg flex-shrink-0
                ${
                  activeTab === tab.id
                    ? "bg-brand text-white font-semibold"
                    : "bg-ui-surface-sunken text-ui-text-muted hover:text-ui-text hover:bg-ui-border"
                }`}
              >
                <span className="hidden sm:inline">{tab.label}</span>
                <span className="sm:hidden">
                  {tab.label
                    .split(" ")
                    .map((w) => w[0])
                    .join("")}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="!p-2 sm:!p-3 md:!p-4 lg:!p-12 max-h-[calc(95vh-120px)] sm:max-h-[calc(95vh-140px)] overflow-y-auto">
          {renderTabContent()}
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ClientSettings;
